import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-added',
  templateUrl: './advanced-reorder-added.component.html'
})
export class AdvancedReorderAddedComponent {
  constructor(public modal: NgbActiveModal) {}
}